import type { ApiExecutionResult } from '../../common/apiResponse'

/** DUPカテゴリID定義 */
export const DupCategoryId = {
  AERIAL_PIC: 'AerialPic',
  PROPERTY_TAX_SCREENING: 'PropertyTaxScreening'
} as const

/** DUPカテゴリID */
export type DupCategoryId = (typeof DupCategoryId)[keyof typeof DupCategoryId]

/** 共通リクエストパラメータ */
export interface CommonParam {
  /** システムID */
  system: string
  /** 自治体コード */
  govCode: string
  /** DUPカテゴリID */
  dupCategoryId: DupCategoryId
}

/** runリクエストパラメータ */
export interface RunParam extends CommonParam {
  /** 災害ID */
  disasterId: string
  /** アップロード先オブジェクトキー */
  key: string
}

/** runForPropscrリクエストパラメータ */
export interface RunForPropscrParam extends CommonParam {
  /** アップロード先オブジェクトキー */
  key: string
  /** フライト開始地点情報種別 */
  homeElevationType: number
  /** フライト開始地点緯度経度 */
  homeElevationLatlng?: {
    latitude: number | undefined
    longitude: number | undefined
  }
  /** フライト開始地点高度 */
  homeElevationValue?: number | undefined
  /** フライト開始地点撮影ファイル名 */
  homeElevationImgFileName?: string
  /** フライト高度 */
  flightAltitude?: number | undefined
}

/** runリザルト */
export interface RunResponseResult {
  /** メッセージ */
  message: string
  /** 実行ARN */
  execution_arn: string
}

/** runレスポンス */
export type RunResponse = ApiExecutionResult<RunResponseResult>
